import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { defaultPreviewSimple } from 'components/atmo-demo/constants';

import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class TopBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onChangeArea = this.onChangeArea.bind(this);
  }

  /**
   * Event hander executed when the user changes the area
   * @param {{ label: string, value: string }} area Selected area
   */
  onChangeArea(area) {
    const { setArea, setViewport } = this.props;
    setArea(area, true);
    setViewport({});
  }

  render() {
    const { areas, selectedArea, pollutant } = this.props;
    return (
      <div className="c-atmo-top-bar">
        {areas.length > 1 &&
          <div>
            <Select classNamePrefix="react-select" placeholder="Select an area" options={areas} value={selectedArea} onChange={this.onChangeArea} />
          </div>
        }
        {areas.length === 1 &&
          <span>{areas[0].label}</span>
        }
        {pollutant && defaultPreviewSimple &&
          <span>{pollutant.label}</span>
        }
        {pollutant && !defaultPreviewSimple &&
          <span>{areas[0].pollutant}</span>
        }
      </div>
    );
  }
}

const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.string])
});

TopBar.propTypes = {
  // Area options for the selector
  areas: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected area option
  selectedArea: optionPropType,
  // Pollutant
  pollutant: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }),
};

TopBar.defaultProps = {
  selectedArea: null,
  pollutant: null
};

export default TopBar;



// WEBPACK FOOTER //
// ./src/components/atmo-demo/components/top-bar/component.js